import useSWR from "swr";

function fetcher(url: string) {
  return (
    fetch(url)
      // Reject if the response is not OK
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
  );
}

export default function useData<T>(
  path: string | (() => string | undefined | null)
) {
  const { data, error, mutate, isValidating } = useSWR<T>(path, fetcher);

  return {
    data,
    isLoading: !data && !error,
    refresh: mutate,
    error,
    isValidating,
  };
}
